<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'cross-analysis-2';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.cross-analysis-2 {
  thead {
    background-color: var(--theme-color-1);
    th {
      color: #fff;
    }
  }
  tbody {
    tr {
      &:nth-child(even) {
        &::after {
          @include _custom_table_bg;
          z-index: 1;
        }
      }
    }
  }
}
</style>
